<footer class="site-footer text-xs">{{ 'footer.copyright' | translate:{year: moment().year()} }}</footer>